module.exports = __webpack_public_path__ + "img/hamburger.e9bd3bd7.svg";